export default (source = '') => {

  /*let basePath = '';
  if (process.env.NODE_ENV === 'production') {
    basePath = process.env.BUILD_PATH;
  }*/

  let basePath = process.env.LOCAL_BUILD_PATH;

  if (process.env.NODE_ENV === 'production') {
    basePath = process.env.BUILD_PATH;
  }
  let iconsObj = {};

  // landmark map marker options
  let marker = {
    default: '',
    hovered: '-hovered',
    hidden: '',
    hiddenHovered: '',
    // hidden: '-hidden',
    // hiddenHovered: '-hidden-hovered',
  };

  // the space map marker options
  if (source === 'thespace-uk') {
    marker = {
      default: '-the-space',
      hovered: '-the-space-hovered',
      hidden: '',
      hiddenHovered: '',
      // hidden: '-the-space',
      // hiddenHovered: '-the-space',
    };
  }

  Object.keys(marker).forEach(key => { // generate icons
    iconsObj[key] = {
      url: basePath + `/img/map-v2-marker${marker[key]}.svg`,
      size: new google.maps.Size(23, 30),
      scaledSize: new google.maps.Size(23, 30),
      // origin: new google.maps.Point(-5, -5),
      // anchor: new google.maps.Point(15, 15),
    };
  });

  return iconsObj;
}
